export enum Role {
    Admin = 'superAdmin',
    User = 'user',
    Customer = 'customer',
}
